"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
const vue_1 = require("vue");
exports.store = (0, vue_1.reactive)({
    isLogin: true,
    isLastStepPage: false,
    isLandingPage: false,
    landingPage: {
        hasHiResImage: false,
        desktopImageURL: "",
        tabletImageURL: "",
        mobileImageURL: "",
        imageAltText: "",
        headerText: "",
    },
    username: "",
    globalErrorMessages: [],
    httpErrorStatusCode: null,
    oAuthSignIn: "",
});
